export default __webpack_public_path__ + "ea1b9ce67586d32de3690a198a2d42e5.png";